module.exports = __webpack_public_path__ + "static/media/ic_tablet.c16f921d.svg";